var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":"","fill-height":""}},[_c('div',{attrs:{"id":"placeholder"}}),_c('Sharedialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }